import requests from './request'

export const reqBanner =()=>requests({url:'/banner',method:'get'})//首页主图
export const reqProducts =()=>requests({url:'/home_product',method:'get'})//首页热门产品
export const reqNews =()=>requests({url:'/article',method:'get'})//首页最新动态
export const reqNewsDetail =(id)=>requests({url:`/article_detail?id=${id}`,method:'get'}) //最新动态详情
export const reqJobs =()=>requests({url:'/recruit_sort',method:'get'})//社招岗位
export const reqJobsList =(id)=>requests({url:`/recruit?sort_id=${id}`,method:'get'})//社招岗位列表
export const reqJobDetail =(id)=>requests({url:`/recruit_detail?id=${id}`,method:'get'})//社招岗位详情
